import Box from "ds/components/Box";
import Button from "ds/components/Button";
import { ChevronDown } from "components/icons/generated";
import useMainNavigationStore from "components/MainNavigation/stores/useMainNavigationStore";
import { selectNavigationShowsExpandedContent } from "components/MainNavigation/selectors/navigationState";
import useMainNavigationDropdownManager from "components/MainNavigation/hooks/useDropdownManager";
import useMainNavigationFadeTransition from "components/MainNavigation/hooks/useFadeTransition";
import useMainNavigationHoverWithDelay, {
  COLLAPSED_SIDEBAR_DROPDOWN_OPEN_DELAY,
} from "components/MainNavigation/hooks/useHoverWithDelay";
import MainNavigationDropdownMenu from "components/MainNavigation/components/atoms/DropdownMenu";

import MainNavigationLogo from "../../Logo";
import useProductSwitcherProducts from "./useProducts";
import ProductSwitcherItem from "./Item";
import styles from "./styles.module.css";

const PRODUCT_SWITCHER_DROPDOWN_ID = "product-switcher";

const MainNavigationProductSwitcher = () => {
  const showsExpandedContent = useMainNavigationStore(selectNavigationShowsExpandedContent);
  const { transitionClasses } = useMainNavigationFadeTransition(!!showsExpandedContent);
  const products = useProductSwitcherProducts();
  const currentProduct = products.find((product) => product.isCurrent);

  const { isOpen, dropdownId, openDropdown, closeDropdown, toggleDropdown } =
    useMainNavigationDropdownManager(PRODUCT_SWITCHER_DROPDOWN_ID);

  const { handleMouseEnter, handleMouseLeave } = useMainNavigationHoverWithDelay({
    onOpen: openDropdown,
    onClose: closeDropdown,
    shouldDisableOpen: !showsExpandedContent,
    openDelay: !showsExpandedContent ? COLLAPSED_SIDEBAR_DROPDOWN_OPEN_DELAY : undefined,
  });

  const triggerComponent = (
    <Button
      variant="ghost"
      size="small"
      active={isOpen}
      endIcon={ChevronDown}
      className={transitionClasses}
      onPress={toggleDropdown}
      aria-label="Switch product"
      aria-expanded={isOpen}
    >
      {currentProduct?.title}
    </Button>
  );

  return (
    <Box shrink="0" align="center" gap="small">
      <MainNavigationLogo />

      <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
        <MainNavigationDropdownMenu
          dropdownId={dropdownId}
          isOpen={isOpen}
          placement={showsExpandedContent ? "bottom left" : "right bottom"}
          className={styles.dropdownMenu}
          triggerComponent={triggerComponent}
        >
          {products.map((product) => (
            <ProductSwitcherItem key={product.id} product={product} onAction={product.onAction} />
          ))}
        </MainNavigationDropdownMenu>
      </Box>
    </Box>
  );
};

export default MainNavigationProductSwitcher;
